import { ActivityOption, NotificationGroupType } from "PFCore/types";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

type NotificationsPanelContextData = {
  engagement?: ActivityOption;
  setEngagement: Dispatch<SetStateAction<ActivityOption | undefined>>;
  role?: ActivityOption;
  setRole: Dispatch<SetStateAction<ActivityOption | undefined>>;
  categories: string[];
  setCategories: Dispatch<SetStateAction<string[]>>;
  showUnreadOnly: boolean;
  setShowUnreadOnly: Dispatch<SetStateAction<boolean>>;
  showImportantOnly: boolean;
  setShowImportantOnly: Dispatch<SetStateAction<boolean>>;
  groupBy: NotificationGroupType;
  setGroupBy: Dispatch<SetStateAction<NotificationGroupType>>;
};

export const NotificationsPanelContext = createContext<NotificationsPanelContextData>(
  {} as NotificationsPanelContextData
);

export const useNotificationsPanelContext = () => {
  const context = useContext(NotificationsPanelContext);

  if (!context) {
    throw new Error("useNotificationsPanelContext must be used within a NotificationsPanelContextProvider");
  }

  return context;
};
